/**
 * Validates an email address based on a standard email structure and allowed TLDs.
 * * @param {string} email 
 * @returns {{ isValid: boolean, errorMessage: string }} Response object with validation rules
 */
export const EmailValidator = (email) => {
    if (!email) {
        return { isValid: false, errorMessage: "Email is required" };
    }

    // 1. Basic structural check (checks format and limits length to 2-6 chars)
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(email)) {
        return { isValid: false, errorMessage: "Please enter a valid email address" };
    }

    // 2. Define your allowed generic and common corporate extensions
    const allowedExtensions = [
        "com", "org", "net", "edu", "gov", "co", "io", "ai", "tech", "in", "us", "uk", "ca", "au"
    ];

    // 3. Extract the extension from the email (e.g., "test@gmail.com" -> "com")
    const parts = email.split('.');
    const extension = parts[parts.length - 1].toLowerCase();

    // 4. Verify if the extension is in our allowed list
    if (!allowedExtensions.includes(extension)) {
        return { 
            isValid: false, 
            errorMessage: "We only accept standard corporate or public email domains (e.g., .com, .net, .co, .io)" 
        };
    }

    return { isValid: true, errorMessage: "" };
};

export default EmailValidator;